export const domain = 'Welcome';

export const APP_TYPE_INDIVIDUAL = 'I';
export const APP_TYPE_CUSTOMER_JOINT = 'C';

// action types
export const SET_APP_INDIVIDUAL = `${domain}/SET_APP_INDIVIDUAL`;
export const SET_APP_JOINT = `${domain}/SET_APP_JOINT`;
export const SET_RETURNED_FROM_THIRD_PARTY_SITE = `${domain}/SET_RETURNED_FROM_THIRD_PARTY_SITE`;
export const SET_PROVIDER_ID = `${domain}/SET_PROVIDER_ID`;
export const SET_RECEIVED_PROVIDER_TO_USE_FROM_STORIS = `${domain}/SET_RECEIVED_PROVIDER_TO_USE_FROM_STORIS`;
export const SET_STORE_NAME = `${domain}/SET_STORE_NAME`;
export const SET_DEFAULT_PROVIDER = `${domain}/SET_DEFAULT_PROVIDER`;
export const SET_USER_CONSENTED = `${domain}/SET_USER_CONSENTED`;
export const SET_ADDITIONAL_PROVIDER_REVIEW_CHECKBOX_DISPLAYED = `${domain}/SET_ADDITIONAL_PROVIDER_REVIEW_CHECKBOX_DISPLAYED`;
export const SET_CFA_TRACE_ID = `${domain}/SET_CFA_TRACE_ID`;
